import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import {numberWithCommas, removeDecimalsIfNotNeeded, calculateDomain} from "../../../../../helpers/formatters";
import Source from "../../../../items/Source";
import MiniLegend from "../../../../items/MiniLegend";

import {BarChart} from "d3plus-react";

class LaborSkillShifts extends Component {

  render() {
    const {clustersData, selectedCluster} = this.props;

    const selectedClusterID = selectedCluster.id;
    const averageClusterID = 14;
    const clustersIds = [selectedClusterID, averageClusterID];

    const filteredData = clustersData.filter(cd => clustersIds.indexOf(cd.cluster_id) > -1);

    const colors = filteredData.map(d => ({color: d.color, label: d.cluster_name}));

    const fields = {
      'net_job_growth_knowledge_intensive_services_2018_30_in_thousands': '<b>Knowledge intensive services</b>',
      'net_job_growth_non_technical_services_2018_30_in_thousands': '<b>Non-technical services</b>',
      'net_job_growth_public_sector_and_healthcare_2018_30_in_thousands': '<b>Public sector & healthcare</b>',
      'net_job_growth_construction_2018_30_in_thousands': '<b>Construction</b>',
      'net_job_growth_industry_2018_30_in_thousands': '<b>Manufacturing</b>',
      'net_job_growth_agriculture_2018_30_in_thousands': '<b>Agriculture</b>'
    };

    const finalData = [];
    let xMax = 0;
    let xMin = 0;
    let value;
    Object.keys(fields).forEach(f => {
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({cluster_id: fd.cluster_id, cluster_name: fd.cluster_name, property: fields[f], value: value, color: fd.color});
        xMax = xMax < value ? value : xMax;
        xMin = xMin > value ? value : xMin;
      });
    });

    const chartConfig = {
      data: finalData.reverse(),
      detectVisible: true,
      groupBy: "cluster_name",
      height: 380,
      discrete: "y",
      y: "property",
      x: "value",
      tooltipConfig: {
        body: d => `<div>${d.property} job growth, thousands: ${removeDecimalsIfNotNeeded(d.value)}</div>`
      },
      yConfig: {
        title: false,
        tickSize: 0,
        minSize: 150,
      },
      legend:false,
      xConfig: {
        title: false,
        tickFormat: tick => `${numberWithCommas(tick)}`,
        domain: calculateDomain(xMin, xMax)
      },
      shapeConfig: {
        fill: d => d.color,
        duration: 0,
        Bar: {
          label: (d) => (`${removeDecimalsIfNotNeeded(d.value)}`)
        }
      },
      groupPadding: 15,
      barPadding: 2,
      legendTooltip: {
        body: "",
        footer: "",
      },
      on: {"click.legend": () => {}}
    };
    return (
      <CarouselItem title="Projected sector shifts" subtitle={<><b>Net change of jobs,</b> 2018-30, in thousands</>}>
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <BarChart config={chartConfig} />
          <Source text="Source: Eurostat, Oxford Economics; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : [],
    selectedCluster: state.settings.map["Clusters"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LaborSkillShifts);
